export default "__VITE_ASSET__BXmTyYI0__"